import { c as _c } from "react/compiler-runtime";
import { alpha, Box } from "@mui/material";
import { styled } from "@mui/material";
import React from "react";
import { Separator } from "react-resizable-panels";
type ResizeHandleProps = {
  id?: string;
};
const StyledPanelResizeHandle = styled(Separator)(({
  theme
}) => ({
  background: "transparent",
  flex: "0 0 12px",
  position: "relative",
  outline: "none",
  minWidth: "12px",
  minHeight: "12px",
  "&:hover": {
    ".ResizeHandleInner": {
      background: alpha(theme.palette.primary.light, 0.3)
    }
  },
  "&[data-resize-handle-active]": {
    ".ResizeHandleInner": {
      background: theme.palette.primary.light
    }
  },
  ".icon": {
    width: "1em",
    height: "1em",
    position: "absolute",
    fontSize: "11px",
    transition: "color 0.2s",
    color: "transparent",
    left: "calc(50% - 11px)",
    top: "calc(50% - 11px)"
  }
}));
export const ResizeHandle: React.FC<ResizeHandleProps> = t0 => {
  const $ = _c(4);
  const {
    id
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      position: "absolute",
      top: 2,
      bottom: 2,
      left: 2,
      right: 2,
      borderRadius: "6px",
      backgroundColor: "transparent",
      transition: "background-color 0.2s linear"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Box className="ResizeHandleInner" sx={t1}><svg className="icon" viewBox="0 0 24 24"><path fill="currentColor" d="M8,18H11V15H2V13H22V15H13V18H16L12,22L8,18M12,2L8,6H11V9H2V11H22V9H13V6H16L12,2Z" /></svg></Box>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== id) {
    t3 = <StyledPanelResizeHandle id={id}>{t2}</StyledPanelResizeHandle>;
    $[2] = id;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};